import { EnrollmentPaymentType } from '../../../external/shared/api/EnrollmentClient.generated';
export { EnrollmentPaymentType } from '../../../external/shared/api/EnrollmentClient.generated';

export const EnrollmentPaymentTypes = Object.values(EnrollmentPaymentType);

export function getPaymentTypeLabelName(paymentType: EnrollmentPaymentType, countryIso2: string | undefined = undefined) {
  switch (paymentType) {
    case EnrollmentPaymentType.CreditCard:
      return 'CreditCard';
    case EnrollmentPaymentType.WireTransfer:
      return 'WireTransferInfo';
    case EnrollmentPaymentType.VirtualWalletPaypal:
      return 'PayPal';
    case EnrollmentPaymentType.VirtualWalletIdeal:
      return 'Ideal';
    case EnrollmentPaymentType.Sepa:
      return 'Sepa';
    case EnrollmentPaymentType.Payflex:
      return 'Payflex';
    case EnrollmentPaymentType.Cod:
      return 'CashOnDelivery';
    case EnrollmentPaymentType.NuveiPaymentPage:
      if (countryIso2 === 'NL') {
        return 'Apple Pay / Google Pay / iDeal';
      } else if (countryIso2 === 'BE') {
        return 'Apple Pay / Google Pay / Bancontact';
      }
      return paymentType;
    default:
      return paymentType;
  }
}

export function isEnrollmentPaymentType(value: string): value is EnrollmentPaymentType {
  return EnrollmentPaymentTypes.includes(value as EnrollmentPaymentType);
}
